let lang = "nl";

const UI = {
  skip: { nl: "Naar de kalender", en: "Skip to calendar" },
  langLabel: { nl: "Taal", en: "Language" },
  conceptNotice: { nl: "CONCEPTVERSIE — Aanbiedingen en kortingen zijn voorlopig en kunnen nog wijzigen.", en: "PREVIEW VERSION — Offers and discounts are provisional and may change." },
  previewLabel: { nl: "Datumdemo · alleen visueel · Europe/Brussels", en: "Date demo · visual only · Europe/Brussels" },
  previewOnly: { nl: "Concept — nog niet te koop", en: "Preview — not for sale yet" },
  simGroup: { nl: "Simuleer een datum", en: "Simulate a date" },
  today: { nl: "Vandaag", en: "Today" },
  posterAlt: { nl: "BLACK NOVEMBER. 30 dagen. 30 deals. www.muskle.com", en: "BLACK NOVEMBER. 30 days. 30 deals. www.muskle.com" },
  posterNote: { nl: "", en: "The wording in this campaign image is part of the artwork and stays in Dutch until an English version is approved." },
  calTitle: { nl: "De deal-kalender", en: "Daily Deal Calendar" },
  calLead: { nl: "30 dagen. 30 deals. Elke dag een nieuwe aanbieding.", en: "30 Days. 30 Deals. A new offer every day." },
  calHint: { nl: "Klik op een dag om naar de aanbieding te gaan. Shoppen kan alleen op de dag zelf.", en: "Click a day to jump to that offer. You can only shop on the day itself." },
  legendToday: { nl: "Vandaag te shoppen", en: "Available to shop today" },
  legendPast: { nl: "Afgelopen, met rode X", en: "Expired, with a red X" },
  legendNext: { nl: "Nog op slot", en: "Still locked" },
  legendGift: { nl: "Cadeaudag", en: "Gift day" },
  dealsKicker: { nl: "Dagelijkse specials", en: "Daily specials" },
  dealsTitle: { nl: "Alle 30 aanbiedingen", en: "All 30 offers" },
  priceNote: { nl: "De winkelprijzen zijn de huidige prijzen op muskle.com. De Black November-korting is in deze preview nog niet verrekend en nog niet actief in de kassa.", en: "Store prices are the current prices on muskle.com. The Black November discount is not applied in this preview and is not active at checkout." },
  auditSummary: { nl: "Controlepunten voor goedkeuring — alleen in deze preview", en: "Approval checks — this preview only" },
  audit1: { nl: "7 en 12 november tonen <strong>-22%</strong> en <strong>-18%</strong>, zoals in de tabel op de planning. De notitie onder die planning zegt dat voor 7 en 12 november geen kortingspercentage was vermeld. Die twee percentages moeten nog bevestigd worden.", en: "7 and 12 November show <strong>-22%</strong> and <strong>-18%</strong>, as in the planning table. The note under that plan says no percentage was listed for 7 and 12 November. Those two percentages still need confirmation." },
  audit2: { nl: "10 november is in de shop <strong>5% Nutrition 51-50</strong>. De planning schrijft “5% 51/50”. De producttekst op muskle.com noemt hetzelfde product ook 51/50. Het is een pre-workout.", en: "10 November is <strong>5% Nutrition 51-50</strong> in the shop. The plan says “5% 51/50”. The product text on muskle.com also calls it 51/50. It is a pre-workout." },
  audit3: { nl: "Zonder shopproduct, en dus zonder winkelknop: MUSKLE Creatine + Taurine 500g, de shaker van €14,90, de handdoek van €9,90, de kousen en de stalen waterfles van 500 ml.", en: "No shop product, and therefore no shop button: MUSKLE Creatine + Taurine 500g, the €14.90 shaker, the €9.90 towel, the socks and the 500 ml steel bottle." },
  toCal: { nl: "Terug naar kalender", en: "Back to Calendar" },
  statusToday: { nl: "Vandaag beschikbaar", en: "Available Today" },
  statusPast: { nl: "Afgelopen", en: "Expired" },
  statusNext: { nl: "Binnenkort", en: "Coming Soon" },
  todayOnly: { nl: "Alleen vandaag", en: "Today Only" },
  heroBefore: { nl: "Black November begint 1 november", en: "Black November Starts 1 November" },
  heroAfter: { nl: "Black November is afgelopen", en: "Black November Has Ended" },
  calBefore: { nl: "Start 1 november", en: "Starts 1 November" },
  calDuring: { nl: "Deal van vandaag", en: "Today's deal" },
  calAfter: { nl: "Campagne afgelopen", en: "Campaign ended" },
  shopDeal: { nl: "Shop de deal", en: "Shop Today's Deal" },
  shopCategory: { nl: "Shop de categorie", en: "Shop the Category" },
  shopBrand: { nl: "Shop het merk", en: "Shop the Brand" },
  shopCreatine: { nl: "Shop alle creatine", en: "Shop All Creatine" },
  noLink: { nl: "Nog geen productlink", en: "No product link yet" },
  dealEnded: { nl: "Deal afgelopen", en: "Deal expired" },
  notYet: { nl: "Binnenkort beschikbaar", en: "Not Yet Available" },
  gift: { nl: "CADEAU", en: "FREE GIFT" },
  giftWord: { nl: "Cadeau", en: "Free Gift" },
  off: { nl: "korting", en: "off" },
  allCreatine: { nl: "Alle creatine", en: "All Creatine" },
  sample: { nl: "VOORBEELD", en: "SAMPLE" },
  sampleShop: { nl: "Voorbeeld · nog niet in de shop", en: "Sample · not in the shop yet" },
  confirm: { nl: "Percentage komt uit de tabel en moet nog bevestigd worden.", en: "This percentage comes from the plan and still needs confirmation." },
  monthName: { nl: "november", en: "November" },
  heroDuring: { nl: "Bekeken datum: {date}. Alleen {day} november is te shoppen.", en: "Viewing date: {date}. Only {day} November can be shopped." },
  heroEnded: { nl: "Bekeken datum: {date}. Alle 30 deals zijn afgesloten.", en: "Viewing date: {date}. All 30 deals have ended." },
  heroLocked: { nl: "Bekeken datum: {date}. November is nog niet begonnen. Alle deals staan op slot.", en: "Viewing date: {date}. November has not started. All deals are locked." }
};

const EN = {
  1: {
    blurb: "MUSKLE Creatine + Taurine 500g with 20% off. This exact product is not in the shop yet, so there is no photo and no shop button."
  },
  2: {
    short: "Amino Acids",
    title: "Amino Acids",
    blurb: "The full amino acids category at 25% off. Only on this day, through the category button.",
    cta: "Shop the Category"
  },
  3: {
    short: "Free shaker",
    title: "Free shaker",
    blurb: "Free shaker worth €14,90 with a purchase from €60. The gift is not listed as a product in the shop yet."
  },
  4: {
    blurb: "Mass Pro+ by Fast Forward Nutrition, 3 kg pack. 20% off, only on this day."
  },
  5: {
    blurb: "Cream of Rice by Trained By JP, 2 kg tub. 20% off."
  },
  6: {
    blurb: "Per4m Hydrate is a drink mix with electrolytes. 25% off."
  },
  7: {
    short: "MUSKLE Brand",
    title: "MUSKLE Brand",
    blurb: "The full MUSKLE brand at 22% off. This percentage still needs confirmation.",
    cta: "Shop the Brand"
  },
  8: {
    title: "BCAA",
    blurb: "BCAA products at 26% off. Only on this day.",
    cta: "Shop the Category"
  },
  9: {
    blurb: "Micronized creatine by Fast Forward Nutrition, 300 grams. 22% off."
  },
  10: {
    blurb: "Pre-workout by 5% Nutrition, 30 servings. 16% off."
  },
  11: {
    short: "Free towel",
    title: "Free towel",
    blurb: "Free towel worth €9,90 with a purchase from €60. The towel is not in the shop yet."
  },
  12: {
    blurb: "Lean Gainer by Fast Forward Nutrition, 2 kg. The plan shows 18% off. This percentage still needs confirmation."
  },
  13: {
    blurb: "Iso Whey Zero by BiotechUSA. 13% off."
  },
  14: {
    title: "All Magnesium",
    blurb: "Magnesium from the range at 18% off. Only on this day.",
    cta: "Shop the Category"
  },
  15: {
    blurb: "Oatmeal by Fast Forward Nutrition, 5 kg bag. 20% off."
  },
  16: {
    short: "Fat Burners",
    title: "Fat Burners",
    blurb: "The fat burners category at 25% off. Only on this day.",
    cta: "Shop the Category"
  },
  17: {
    blurb: "The 300 gram option of BiotechUSA Creatine Micronized Zero. 23% off."
  },
  18: {
    short: "Free socks",
    title: "Free socks",
    blurb: "Free socks with a purchase from €60. The socks are not in the shop yet."
  },
  19: {
    blurb: "Shilajit by MUSKLE, sold as Shilajit+ Gummies. 35% off."
  },
  20: {
    short: "Omega",
    title: "All Omega-3",
    blurb: "Omega-3 from the range at 16% off. Only on this day.",
    cta: "Shop the Category"
  },
  21: {
    blurb: "MUSKLE intra-workout with EAA and BCAA, Blueberry / Lemonade, 600 g. 21% off."
  },
  22: {
    short: "Free steel bottle",
    title: "Free 500 ml steel bottle",
    blurb: "Free 500 ml steel bottle, worth €14,90, with a purchase over €60. That bottle is not in the shop yet."
  },
  23: {
    blurb: "Pre-workout gummies by MUSKLE, blueberry, 120 pieces. 50% off."
  },
  24: {
    short: "Vitamins",
    title: "Vitamins",
    blurb: "Vitamins and minerals at 24% off. Only on this day.",
    cta: "Shop the Category"
  },
  25: {
    short: "Collagen",
    title: "Collagen",
    blurb: "Collagen from the range at 20% off. Only on this day.",
    cta: "Shop the Category"
  },
  26: {
    blurb: "MUSKLE Test Male, 120 capsules. 40% off."
  },
  27: {
    short: "All Creatine",
    title: "All Creatine",
    blurb: "Black Friday: all creatine at 27% off. This is the only deal on Friday 27 November.",
    cta: "Shop All Creatine"
  },
  28: {
    blurb: "Hydro Gold by Fast Forward Nutrition. 15% off."
  },
  29: {
    short: "Pre-workouts",
    title: "Pre-Workouts",
    blurb: "The pre-workout category at 22% off. Only on this day.",
    cta: "Shop the Category"
  },
  30: {
    title: "ESN Whey and Scitec Whey",
    blurb: "Cyber Monday: whey from ESN and Scitec at 20% off. There is no separate whey category, so both brands are on this card."
  }
};

const NAME_EN = {
  "Creatine Monohydraat Gummies": "Creatine Monohydrate Gummies",
  "FFN Magnesium Bisglycinaat": "FFN Magnesium Bisglycinate",
  "Supplement Needs Vitamine D3 + K2": "Supplement Needs Vitamin D3 + K2",
  "ESN Collagen Peptiden": "ESN Collagen Peptides"
};

const CTA_KEYS = {
  "Shop de deal": "shopDeal",
  "Shop de categorie": "shopCategory",
  "Shop het merk": "shopBrand",
  "Shop alle creatine": "shopCreatine"
};

function t(key) {
  const row = UI[key];
  if (!row) return "";
  return row[lang] || row.nl || "";
}

function localeTag() {
  return lang === "en" ? "en-GB" : "nl-NL";
}

function field(deal, key) {
  if (lang === "en" && EN[deal.day] && EN[deal.day][key]) return EN[deal.day][key];
  return deal[key] || "";
}

function productName(name) {
  if (lang === "en" && NAME_EN[name]) return NAME_EN[name];
  return name;
}

function discountLabel(deal) {
  if (deal.gift || deal.discount === "CADEAU") return t("gift");
  return deal.discount;
}

function conditionText(deal) {
  if (!deal.condition) return "";
  if (lang === "nl") return deal.condition;
  return deal.condition
    .replace("Bij een aankoop vanaf ", "With a purchase from ")
    .replace("Bij een aankoop boven ", "With a purchase over ");
}

function priceText(deal) {
  if (!deal.price) return "";
  if (lang === "nl") return deal.price;
  return deal.price
    .replace("Huidige winkelprijs vanaf ", "Current store price from ")
    .replace("Huidige winkelprijs ", "Current store price ");
}

function ctaLabel(label) {
  if (lang === "en" && CTA_KEYS[label]) return t(CTA_KEYS[label]);
  return label;
}

function readInitialLang() {
  const query = new URLSearchParams(location.search).get("lang");
  if (query === "en" || query === "nl") return query;
  try {
    const saved = localStorage.getItem("muskle-bn-lang");
    if (saved === "en" || saved === "nl") return saved;
  } catch (err) {
    return "nl";
  }
  return "nl";
}

function persistLang() {
  try { localStorage.setItem("muskle-bn-lang", lang); } catch (err) { /* private mode */ }
  const params = new URLSearchParams(location.search);
  if (params.get("lang") === lang) return;
  params.set("lang", lang);
  history.replaceState(null, "", location.pathname + "?" + params.toString() + location.hash);
}

function formatLongDate(day) {
  const date = new Date(Date.UTC(2026, 10, day, 12));
  const formatted = new Intl.DateTimeFormat(localeTag(), {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC"
  }).format(date);
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

function formatDayMonth(day, monthIndex) {
  const date = new Date(Date.UTC(2026, monthIndex, day, 12));
  const formatted = new Intl.DateTimeFormat(localeTag(), {
    day: "numeric",
    month: "long",
    timeZone: "UTC"
  }).format(date);
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

function formatMonthShort(monthIndex) {
  return new Intl.DateTimeFormat(localeTag(), { month: "short", timeZone: "UTC" })
    .format(new Date(Date.UTC(2026, monthIndex, 1, 12)))
    .replace(".", "");
}

function formatWeekdayShort(day) {
  const date = new Date(Date.UTC(2026, 10, day, 12));
  return new Intl.DateTimeFormat(localeTag(), { weekday: "short", timeZone: "UTC" })
    .format(date)
    .replace(".", "");
}
